import Loadable from '@loadable/component';
import Redirect from 'app/common/components/redirect';

const History = Loadable(async () => import('./components/history/history-container.js'));

const schemaRoutes = {
  '/schema': {
    components: { main: Redirect },
    from: /\/schema/,
    to: '/api',
    '/editor': {
      components: { main: Redirect },
      from: /\/schema\/editor/,
      to: '/api?view=json'
    },
    '/history': {
      components: { main: History, sectionName: 'Schema History' }
    }
  }
};

export default schemaRoutes;
